import User from './user/user';
import UserAdminComponent from './user-admin-component'
import UserAdminService from './user-admin-service';
import PreRegisterModal from './pre-register-modal/pre-register-modal';

/***
 * The User Admin page, allowing an Admin to update the status of the existing users.
 */
const users = angular
    .module('FacilityData.UserAdmin', [
        User,
        PreRegisterModal
    ])
    .component('userAdmin', UserAdminComponent)
    .service('UserAdminService', UserAdminService)
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider
            .state('app.user-admin', {
                url: '/user-admin/',
                component: 'userAdmin',
                resolve: {
                    userAuth : (
                        $state,
                        updateUser,
                        CurrentUser,
                    ) => {
                        if (!CurrentUser.isUserAdmin()) {
                            $state.go('app.home', {}, {reload: true});
                        }
                    },
                    userList: (UserAdminService) =>  UserAdminService.getUsers(),
                    clientList: (CommonRequest) => CommonRequest.getClients(),
                    roleList: (CommonRequest) => CommonRequest.getRoles(),
                    permissionList: (CommonRequest) => CommonRequest.getPermissions()
                }
            });
    })
    .name;

export default users;


// WEBPACK FOOTER //
// ./app/components/user-admin/user-admin.js